import React from "react";
import styled from "styled-components";
import { textGradient } from "../GradientBox";

export const BiologicalAgeCheckIllustration: React.FC = () => {
  return (
    <Wrapper>
      <Positioned right={0} bottom={0}>
        <img
          style={{ height: 187, width: 201 }}
          src={`/biological-age-check-landing/old.png`}
        />
      </Positioned>
      <Positioned left={0} top={0}>
        <img
          style={{ height: 187, width: 201 }}
          src={`/biological-age-check-landing/young.png`}
        />
      </Positioned>
      <Positioned right={54} top={36}>
        <SlantedRectangle height={39} width={74}>
          <AgeGuessText>35?</AgeGuessText>
        </SlantedRectangle>
      </Positioned>
      <Positioned left={52} bottom={42}>
        <SlantedRectangle height={39} width={74}>
          <AgeGuessText>55?</AgeGuessText>
        </SlantedRectangle>
      </Positioned>
    </Wrapper>
  );
};

export default BiologicalAgeCheckIllustration;

const Wrapper = styled.div`
  width: 300px;
  height: 333px;
`;

const Positioned: React.FC<{
  right?: number;
  left?: number;
  bottom?: number;
  top?: number;
  children?: React.ReactNode;
}> = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        left: props.left,
        right: props.right,
        top: props.top,
        bottom: props.bottom,
      }}
    >
      {props.children}
    </div>
  );
};

const SlantedRectangle: React.FC<{
  height: number;
  width: number;
  children?: React.ReactNode;
}> = (props) => {
  return (
    <div
      style={{
        position: "relative",
        height: props.height,
        width: props.width,
        padding: 0,
      }}
    >
      <SlantedBackground />
      <SlantedContent>{props.children}</SlantedContent>
    </div>
  );
};

const SlantedBackground = styled.div`
  position: absolute;
  transform: skew(-30deg);
  background: white;
  width: 100%;
  height: 100%;
`;

const SlantedContent = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const AgeGuessText = styled.h1`
  font-size: 31px;
  font-weight: bold;
  background: ${textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
`;
